const INDIAN_MOBILE_PATTERN = /^[6-9]\d{9}$/;

const normalizePhone = (value) => {
  const digitsAndPlus = value.replace(/[^\d+]/g, '');

  if (digitsAndPlus.startsWith('+91') && digitsAndPlus.length === 13) return digitsAndPlus.slice(3);
  if (digitsAndPlus.startsWith('91') && digitsAndPlus.length === 12) return digitsAndPlus.slice(2);
  if (digitsAndPlus.startsWith('0') && digitsAndPlus.length === 11) return digitsAndPlus.slice(1);

  return digitsAndPlus;
};

const setMessage = (messageEl, text, variant) => {
  messageEl.textContent = text;
  messageEl.classList.toggle('pre-launch-hero__form-message--error', variant === 'error');
  messageEl.classList.toggle('pre-launch-hero__form-message--success', variant === 'success');
  messageEl.removeAttribute('hidden');
};

const handleSubmit = (event) => {
  event.preventDefault();

  const form = event.currentTarget;
  const input = form.querySelector('.pre-launch-hero__input');
  const submitButton = form.querySelector('.pre-launch-hero__button');
  const messageEl = form.querySelector('.pre-launch-hero__form-message');
  const normalizedPhone = normalizePhone(input.value.trim());

  if (!INDIAN_MOBILE_PATTERN.test(normalizedPhone)) {
    setMessage(messageEl, 'Please enter a valid 10-digit mobile number.', 'error');
    return;
  }

  submitButton.disabled = true;

  if (!window.clevertap) {
    console.warn('CleverTap SDK not available');
    setMessage(messageEl, 'Something went wrong. Please try again.', 'error');
    submitButton.disabled = false;
    return;
  }

  try {
    const formattedPhone = `+91${normalizedPhone}`;

    window.clevertap.event.push('Pre-Launch Notify Me Signup', { 'Phone Number': formattedPhone });
    window.clevertap.onUserLogin.push({
      Site: {
        Identity: formattedPhone,
        Phone: formattedPhone,
      },
    });

    setMessage(messageEl, "Thanks! We'll notify you when we launch.", 'success');
    input.value = '';
    input.readOnly = true;
  } catch (error) {
    console.warn(error);
    setMessage(messageEl, 'Something went wrong. Please try again.', 'error');
    submitButton.disabled = false;
  }
};

const initVideo = (video) => {
  const isDesktop = window.matchMedia('(min-width: 768px)').matches;
  const breakpoint = isDesktop ? 'desktop' : 'mobile';
  const source =
    video.querySelector(`source[data-breakpoint="${breakpoint}"]`) ?? video.querySelector('source[data-src]');

  if (!source?.dataset.src) return;

  source.src = source.dataset.src;

  if (isDesktop && video.dataset.posterDesktop) {
    video.poster = video.dataset.posterDesktop;
  }

  video.load();
};

const handlePhoneInput = (event) => {
  const input = event.currentTarget;

  input.value = normalizePhone(input.value).slice(0, 10);
};

document.addEventListener('DOMContentLoaded', () => {
  const forms = document.querySelectorAll('.pre-launch-hero__form');

  for (const form of forms) {
    form.addEventListener('submit', handleSubmit);
  }

  const phoneInputs = document.querySelectorAll('.pre-launch-hero__input');

  for (const phoneInput of phoneInputs) {
    phoneInput.addEventListener('input', handlePhoneInput);
  }

  const videos = document.querySelectorAll('.pre-launch-hero__video');

  for (const video of videos) {
    initVideo(video);
  }
});
